module.exports = __webpack_public_path__ + "img/bg4.74e830fc.png";